import uuid from 'react-uuid'
import {snapNoResizeCRail, snapResizeCRail, snap} from "../Plan/snap";
import {
    addSleeve as addSleeveAction,
    moveSleeve as moveSleeveAction,
    removeSleeve as removeSleeveAction,
    addBlockOut as addBlockOutAction,
    resizeBlockOut as resizeBlockOutAction,
    moveBlockOut as moveBlockOutAction,
    removeBlockOut as removeBlockOutAction,
    addCRail as addCRailAction,
    resizeCRail as resizeCRailAction,
    moveCRail as moveCRailAction,
    removeCRail as removeCRailAction,
    addGrounding as addGroundingAction,
    moveGrounding as moveGroundingAction,
    removeGrounding as removeGroundingAction,
    addWallDrainage as addWallDrainageAction,
    moveWallDrainage as moveWallDrainageAction,
    removeWallDrainage as removeWallDrainageAction,

} from "../../features/vault/vaultSlice";
import {
    addCircularElement,
    moveCircularElement,
    previewAddCircularElement,
    previewMoveCircularElement
} from "./circularElementDomainFunctions";
import {SNAP_GRID_SIZE} from "../../constants";
import {getGridLinePositions} from "../Plan/Configuration/gridLinePositions";

const snapResizeRect = (rect, gridWidth, gridHeight) => {
    const snapLength = (length, cellWidth) => {
        return Math.round(length / cellWidth) * cellWidth
    }
    const width = snapLength(rect.width, SNAP_GRID_SIZE)
    const height = snapLength(rect.height, SNAP_GRID_SIZE)
    const verticalGridLinePositions = getGridLinePositions(gridWidth, SNAP_GRID_SIZE, true)
        .filter(gridPos => gridPos <= gridWidth - width)
    const horizontalGridLinePositions = getGridLinePositions(gridHeight, SNAP_GRID_SIZE, true)
        .filter(gridPos => gridPos <= gridHeight - height)

    return {
        x: snap(rect.x, verticalGridLinePositions),
        y: snap(rect.y, horizontalGridLinePositions),
        width,
        height
    }
}

const snapMoveRect = (rect, gridWidth, gridHeight) => {
    const width = rect.width
    const height = rect.height
    const verticalGridLinePositions = [
        ...getGridLinePositions(gridWidth, SNAP_GRID_SIZE, true),
        (gridWidth - rect.width),
        (gridWidth - rect.width) / 2
    ]
        .filter(gridPos => gridPos <= gridWidth - width && gridPos >= 0)
    const horizontalGridLinePositions = [
        ...getGridLinePositions(gridHeight, SNAP_GRID_SIZE, true),
        gridHeight - rect.height,
        (gridHeight - rect.height) / 2
    ]
        .filter(gridPos => gridPos <= gridHeight - height && gridPos >= 0)

    return {
        x: snap(rect.x, verticalGridLinePositions),
        y: snap(rect.y, horizontalGridLinePositions),
        width,
        height
    }
}

const previewAddBlockOut = (configAreaWidth, configAreaHeight, item) => {
    const snapped = {
        ...item,
        ...snapMoveRect(item, configAreaWidth, configAreaHeight)
    }

    return {...item, x: snapped.x, y: snapped.y}
}

const addBlockOut = (dispatch, configAreaWidth, configAreaHeight, wallIndex, item) => {
    const snapped = {
        ...item,
        ...snapMoveRect(item, configAreaWidth, configAreaHeight)
    }
    const blockOut = {id: uuid(), ...item, x: snapped.x, y: snapped.y}

    if (Number.isFinite(snapped.x) && Number.isFinite(snapped.y)) {
        dispatch(addBlockOutAction({wallIndex, blockOut}))
    }
    return blockOut
}

const previewMoveBlockOut = (configAreaWidth, configAreaHeight, item) => {
    const snapped = {
        ...item,
        ...snapMoveRect(item, configAreaWidth, configAreaHeight)
    }

    return {...item, x: snapped.x, y: snapped.y}
}

const moveBlockOut = (dispatch, configAreaWidth, configAreaHeight, wallIndex, item) => {
    const snapped = {
        ...item,
        ...snapMoveRect(item, configAreaWidth, configAreaHeight)
    }

    dispatch(moveBlockOutAction({wallIndex, id: item.id, x: snapped.x, y: snapped.y}))
    return {...item, x: snapped.x, y: snapped.y}
}

const resizeBlockOut = (dispatch, configAreaWidth, configAreaHeight, wallIndex, item) => {
    const snappedRect = snapResizeRect(item, configAreaWidth, configAreaHeight)
    const {x, y, width, height} = snappedRect

    dispatch(resizeBlockOutAction({wallIndex, id: item.id, width, height}))
    dispatch(moveBlockOutAction({wallIndex, id: item.id, x, y}))
    return {...item, ...snappedRect}
}

const previewResizeBlockOut = (configAreaWidth, configAreaHeight, item) => {
    const snappedRect = snapResizeRect(item, configAreaWidth, configAreaHeight)

    return {...item, ...snappedRect}
}

const getSnappedCRail = (configAreaWidth, configAreaHeight, item) => {
    return {
        ...item,
        ...snapNoResizeCRail(item, configAreaWidth, configAreaHeight)
    }
}

const previewAddCRail = (configAreaWidth, configAreaHeight, item) => {
    return getSnappedCRail(configAreaWidth, configAreaHeight, item)
}

const addCRail = (dispatch, configAreaWidth, configAreaHeight, wallIndex, item) => {
    const snapped = getSnappedCRail(configAreaWidth, configAreaHeight, item)
    const cRail = {id: uuid(), ...item, x: snapped.x, y: snapped.y}

    if (Number.isFinite(snapped.x) && Number.isFinite(snapped.y)) {
        dispatch(addCRailAction({wallIndex, cRail}))
    }
    return cRail
}

const previewMoveCRail = (configAreaWidth, configAreaHeight, item) => {
    return getSnappedCRail(configAreaWidth, configAreaHeight, item)
}

const moveCRail = (dispatch, configAreaWidth, configAreaHeight, wallIndex, item) => {
    const snapped = getSnappedCRail(configAreaWidth, configAreaHeight, item)

    dispatch(moveCRailAction({wallIndex, id: item.id, x: snapped.x, y: snapped.y}))
    return snapped
}

const resizeCRail = (dispatch, configAreaWidth, configAreaHeight, wallIndex, item, direction) => {
    const snappedCRail = snapResizeCRail(item, configAreaWidth, configAreaHeight, direction)

    dispatch(resizeCRailAction({wallIndex, id: item.id, length: snappedCRail.length}))
    dispatch(moveCRailAction({wallIndex, id: item.id, x: snappedCRail.x, y: snappedCRail.y}))
    return snappedCRail
}

const previewResizeCRail = (configAreaWidth, configAreaHeight, item, direction) => {
    return snapResizeCRail(item, configAreaWidth, configAreaHeight, direction)
}

export const createVaultDomainFunctions = (dispatch, width, height, wallIndex) => {
    return {
        blockOutFunctions: {
            previewAdd: item => previewAddBlockOut(width, height, item),
            add: item => addBlockOut(dispatch, width, height, wallIndex, item),
            previewMove: item => previewMoveBlockOut(width, height, item),
            move: item => moveBlockOut(dispatch, width, height, wallIndex, item),
            remove: id => dispatch(removeBlockOutAction({wallIndex, id})),
            previewResize: item => previewResizeBlockOut(width, height, item),
            resize: item => resizeBlockOut(dispatch, width, height, wallIndex, item)
        },
        sleeveFunctions: {
            previewAdd: item => previewAddCircularElement(width, height, item),
            add: item => addCircularElement(
                item => dispatch(addSleeveAction({wallIndex, sleeve: item})),
                width,
                height,
                item
            ),
            previewMove: item => previewMoveCircularElement(width, height, item),
            move: item => moveCircularElement(
                (id, x, y) => dispatch(moveSleeveAction({wallIndex, id, x, y})),
                width,
                height,
                item
            ),
            remove: id => dispatch(removeSleeveAction({wallIndex, id}))
        },
        groundingFunctions: {
            previewAdd: item => previewAddCircularElement(width, height, item),
            add: item => addCircularElement(
                item => dispatch(addGroundingAction({wallIndex, grounding: item})),
                width,
                height,
                item
            ),
            previewMove: item => previewMoveCircularElement(width, height, item),
            move: item => moveCircularElement(
                (id, x, y) => dispatch(moveGroundingAction({wallIndex, id, x, y})),
                width,
                height,
                item
            ),
            remove: id => dispatch(removeGroundingAction({wallIndex, id}))
        },
        drainageFunctions: {
            previewAdd: item => previewAddCircularElement(width, height, item),
            add: item => addCircularElement(
                item => dispatch(addWallDrainageAction({wallIndex, drainage: item})),
                width,
                height,
                item
            ),
            previewMove: item => previewMoveCircularElement(width, height, item),
            move: item => moveCircularElement(
                (id, x, y) => dispatch(moveWallDrainageAction({wallIndex, id, x, y})),
                width,
                height,
                item
            ),
            remove: id => dispatch(removeWallDrainageAction({wallIndex, id}))
        },
        cRailFunctions: {
            previewAdd: item => previewAddCRail(width, height, item),
            add: item => addCRail(dispatch, width, height, wallIndex, item),
            previewMove: item => previewMoveCRail(width, height, item),
            move: item => moveCRail(dispatch, width, height, wallIndex, item),
            remove: id => dispatch(removeCRailAction({wallIndex, id})),
            previewResize: (item, direction) => previewResizeCRail(width, height, item, direction),
            resize: (item, direction) => resizeCRail(dispatch, width, height, wallIndex, item, direction)
        }
    }
}
